/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import ListTitle from '../../../../components/ListTitle'
import Datagrid from '../../../../components/Datagrid/Datagrid'
import Filter from '../../../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)

export default function UserGroupsList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            sort={{ field: 'code', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Group" />
                <Datagrid {...props}>
                    <TextField
                        label="Code"
                        headerClassName={classes.myHeader}
                        source="code"
                    />
                    <TextField
                        label="Description"
                        headerClassName={classes.myHeader}
                        source="description"
                    />
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/SS_GroupTAB"
                        />
                    ) : (
                        <EditButton basePath="/SS_GroupTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

UserGroupsList.defaultProps = {
    quickSearch: false,
}
UserGroupsList.propTypes = {
    quickSearch: PropTypes.bool,
}
